import { render, staticRenderFns } from "./XslvList.vue?vue&type=template&id=2a267a56&scoped=true"
import script from "./XslvList.vue?vue&type=script&lang=js"
export * from "./XslvList.vue?vue&type=script&lang=js"
import style0 from "./XslvList.vue?vue&type=style&index=0&id=2a267a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a267a56",
  null
  
)

export default component.exports